import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfigureSettingsComponent } from './configure-settings.component';

const routes: Routes = [
  {
    path: '',
    component: ConfigureSettingsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigureSettingsRoutingModule {}
